import {ListTodoIcon} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import i18n from '@/i18n';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'tasks',
    children: [
      {
        path: '',
        loader: protectedLoader('TASKS', 'VIEW_TASKS'),
        async lazy() {
          const {TasksPage} = await import('./pages/TasksPage');
          return {element: <TasksPage />};
        },
      },
    ],
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/tasks',
    text: i18n.t('Tasks'),
    icon: <ListTodoIcon />,
    permission: 'VIEW_TASKS',
    entitlement: 'TASKS',
  },
] as MenuItemElement[];
